import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SubscriptionManagementApiService } from './subscription-management.api.service';
import { DevicesPayload } from '../../../equipment/devices/components/devices.models';
import { SubscriptionManagement, SubscriptionManagementTable } from '../subscription-management.types';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionManagementService {
  private readonly apiService = inject(SubscriptionManagementApiService);

  getTableData(tableState: DevicesPayload): Observable<SubscriptionManagementTable> {
    return this.apiService.getAll(tableState).pipe(
      map(({ items, totalCount }) => {
        const data = items?.map((item: SubscriptionManagement) => {
          return {
            ...item,
            reportGroup: item.reportGroup ?? '',
            duration: item.duration ?? ('' as const),
            edit: ''
          };
        });
        return { data, total: totalCount };
      }),
      catchError(() => of({ data: [], total: 0 }))
    );
  }
}
